import { render, staticRenderFns } from "./PopoverFront.vue?vue&type=template&id=5d6cff67&scoped=true"
import script from "./PopoverFront.vue?vue&type=script&setup=true&lang=js"
export * from "./PopoverFront.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PopoverFront.vue?vue&type=style&index=0&id=5d6cff67&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6cff67",
  null
  
)

export default component.exports